import request from '../request'

///cosys/design/change/detail/{id}
// 设计修改通知单详情
export function fetchDesignPlanReviseDetail(id) {
    return request({
        url: `/project-service/cosys/design/revise/detail/${id}`,
        method: 'get',
    })
}

export function resubmitDesignPlanRevise(data) {
    return request({
        url: '/project-service/cosys/design/revise/resubmit',
        method: 'post',
        data
    })
}
